import * as escape from '../common/utils/escape';

const TAG_NAME = 'sb-pair-list-wrapper';

interface PairListJson {
  [key: string]: string[]
}

/** This is only intended for use with PairList elements in SiteBuilder forms. It assumes a lot of HTML in its contents.
 *  It's set up this way so when things like the edit submission dialog have one of these in, it works the same as
 *  on the live form. */
class SbPairListWrapper extends HTMLElement {
  connectedCallback() {
    if (!this.isConnected) {
      return;
    }

    const json = JSON.parse(this.querySelector('.pair-list-json').innerHTML) as PairListJson;
    const selects = this.querySelectorAll<HTMLSelectElement>('select');
    const firstSelect = selects[0];
    const secondSelect = selects[1];

    firstSelect.addEventListener('change', () => {
      const newVal = firstSelect.value;
      const newSelect2Vals = json[newVal.replace('1=', '')]; // We need to strip out the weird formatting of values used by forms
      secondSelect.innerHTML = newSelect2Vals.map ((value) => {
        return `<option value="2=${escape.html(value)}">${escape.html(value)}</option>`
      }).join('\n')
    });
  }
}

window.customElements.define(TAG_NAME, SbPairListWrapper)
